<template>
  <wrap-container>
    <wrap-container class="lote-container">
      <number-input
        label="Lote"
        name="lote"
        :required="false"
        maxlength="3"
        v-model="model.lote"
        @input="onInput"
        :disabled="!isEmpty(model.casa)"
        :value="model.lote"
        quantumObfuscate
      >
      </number-input>
    </wrap-container>
    <wrap-container class="grid-data">
      <text-input
        class="col1"
        label="Manzana"
        v-model="model.manzana"
        @input="onInput"
        maxlength="5"
        name="manzana"
        :required="false"
        :value="model.manzana"
        quantumObfuscate
      >
      </text-input>
      <number-input
        class="col2"
        label="Casa"
        v-model="model.casa"
        @input="onInput"
        maxlength="3"
        :disabled="!isEmpty(model.lote)"
        name="casa"
        :required="false"
        quantumObfuscate
      >
      </number-input>
    </wrap-container>
    <wrap-container class="grid-data">
      <text-input
        class="col1"
        label="Sector"
        v-model="model.sector"
        @input="onInput"
        maxlength="5"
        name="sector"
        :required="false"
        quantumObfuscate
      >
      </text-input>
      <text-input
        class="col2"
        label="Parcela"
        v-model="model.parcela"
        @input="onInput"
        maxlength="3"
        name="parcela"
        :required="false"
        quantumObfuscate
      >
      </text-input>
    </wrap-container>
    <wrap-container v-show="entrecallesReq">
      <p>¿Entre qué calles está?</p>
      <text-input
        label="Entre calle"
        v-model="model.calle1"
        @input="onInput"
        maxlength="40"
        name="calle1"
        :required="entrecallesReq"
        quantumObfuscate
      >
      </text-input>
      <text-input
        label="Y calle"
        v-model="model.calle2"
        @input="onInput"
        maxlength="40"
        name="calle2"
        :required="entrecallesReq"
        quantumObfuscate
      >
      </text-input>
    </wrap-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import TextInput from "@/components/core/TextInput";
import NumberInput from "@/components/core/NumberInput";
import { isEmpty } from "@/utils";

export default {
  name: "DatosAdicionales",
  props: {
    value: {},
    entrecallesReq: Boolean
  },
  data() {
    return {
      model: this.value
    };
  },
  components: {
    WrapContainer,
    TextInput,
    NumberInput
  },
  methods: {
    isEmpty,
    onInput() {
      this.$emit("input", this.model);
    }
  },
  destroyed() {
    this.model.manzana = "";
    this.model.lote = "";
    this.model.casa = "";
    this.model.sector = "";
    this.model.parcela = "";
    this.$emit("input", this.model);
  }
};
</script>

<style scoped>
.lote-container {
  margin-bottom: 24px;
}

.grid-data {
  display: grid;
  grid-template: auto / 1fr 1fr;
  grid-template-areas: "col1 col2";
  gap: 24px;
}

.col1 {
  grid-area: col1;
}

.col2 {
  grid-area: col2;
}
</style>
